import { useEffect, useState } from "react";
import { _BudgetMovementFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { MASK_MONEY } from "../../theme/Component/BasicTable2";
import { PrintJson } from "../../theme/Component/PrintJson";
import { InputMoney } from "../../theme/Input/InputMoney";
import { SelectBudgetResourceForYear } from "../../admin/configuracion/BudgetResource/BudgetResourceForYear";
import { SelectBudgetSourceForYear } from "../../admin/configuracion/BudgetSource/SelectBudgetSourceForYear";
import { BudgetResourceEditor } from "../../admin/configuracion/BudgetResource/BudgetResource.Editor";
import { SelectBudgetSource } from "../../admin/configuracion/BudgetSource/SelectBudgetSource";
import { AdquisitionItemSelector } from "../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { SelectBudgetType } from "../../admin/configuracion/select/SelectBudgetType";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { SelectBudgetIDByIDAdquisitionItem } from "../../contract/select/SelectBudgetIDByIDAdquisitionItem";

interface Props {
    formData: Record<string, any>;
    onChange: Function;
    rows?: any;
    updateRows?: any;
}


export const RegisterMovementBudgetValue = ({ onChange, formData, rows, updateRows }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_BudgetMovementFactory);
    const [adquisitionItemFrom, setAdquisitionItemFrom] = useState<any>({});
    const [adquisitionItemDestiny, setAdquisitionItemDestiny] = useState<any>({});
    const [initBean, setInitBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);

    const [modalContra, setModalContra] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalCredit, setModalCredit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Saldo del Rubro Contracrédito', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Contracredito', property: 'ContraCreditValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Crédito', property: 'CreditValue', visible: true, mask: MASK_MONEY },
        { title: 'PAA', property: 'IDAdquisitionItemFrom', visible: true, mask: MASK_NUMBER },
        { title: 'PAA destino', property: 'IDAdquisitionItemDestinity', visible: true, mask: MASK_NUMBER },
        { title: 'Observación', property: 'Description', visible: true },
    ]

    useEffect(() => {
        if (rows) {
            setLista(rows);
        }
    }, [rows])

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-fill', visible: _single.canEdit(), evento: () => { editar() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { eliminarItem() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createItemCC = () => {
        setBean({ IDBudgetType: formData.IDBudgetType });
        setInitBean({});
        setAdquisitionItemFrom({});
        setModalContra({ ...modalContra, "view": true, "name": "Crear Linea de Contra Crédito" })
    }

    const createItemCredit = () => {
        setBean({ IDBudgetType: formData.IDBudgetType });
        setInitBean({});
        setAdquisitionItemDestiny({});
        setModalCredit({ ...modalCredit, "view": true, "name": "Crear Linea de Crédito" })
    }
    const editar = () => {
        if (bean.ContraCreditValue > 0)
            setModalContra({ ...modalContra, "view": true, "name": "Crear Linea de Contra Crédito" })
        else
            setModalCredit({ ...modalCredit, "view": true, "name": "Crear Linea de Crédito" })
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const iconButtonsItem = [
        { nombre: 'Agregar ContraCredito', visible: _single.canCreate(), icono: 'ri-creative-commons-line', evento: createItemCC },
        { nombre: 'Agregar Crédito', visible: _single.canCreate(), icono: 'ri-copyright-line', evento: createItemCredit },
    ]

    const createNewItemCC = () => {
        if (bean.Value <= 0) {
            toast.error("No se puede continuar. El rubro tiene un saldo negativo.");
            return;
        } else {
            const updatedLista = lista.filter((item: any) =>
                JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
            );

            instance.createBudgetRowForContraCredit(bean.IDBudgetType, bean.IDBudgetResourceFrom, bean.IDBudgetSourceFrom, bean.BudgetIDFromStr, bean.Value, bean.Description, adquisitionItemFrom.IDAdquisitionItem).then(
                (resp) => {
                    let temp = [...updatedLista, {
                        DataBeanProperties: resp,
                        DataBeanName: 'budget.Budget'
                    }];
                    setLista(temp);
                    setBean({});
                    setModalContra({ ...modalContra, "view": false })
                }
            ).catch(
                err => {
                    toast.error(err);
                }
            )
        }
    }

    const createNewItemCredit = () => {

        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        instance.createBudgetRowForCredit(bean.IDBudgetType ?? formData.IDBudgetType, bean.IDBudgetResourceDestinity, bean.IDBudgetSourceDestinity, bean.BudgetIDDestinityStr, bean.Value, bean.Description, adquisitionItemDestiny.IDAdquisitionItem).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModalCredit({ ...modalCredit, "view": false })
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const setRowBean = (object: any) => {
        setBean(object);
        setAdquisitionItemDestiny({ IDAdquisitionItem: bean.IDAdquisitionItemDestinity })
        setAdquisitionItemFrom({ IDAdquisitionItem: bean.IDAdquisitionItemFrom })
        setInitBean(object)
    }

    useEffect(() => {
        onChange(lista);
    }, [lista])

    const [isPaa, setIsPaa] = useState<boolean>(false);

    useEffect(() => {
        setBean({ IDBudgetType: formData.IDBudgetType })
        setAdquisitionItemDestiny({});
        setAdquisitionItemFrom({});
    }, [isPaa])

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
                {/* <PrintJson json={formData}/> */}
            </div>

            <div className="col-md-12">
                <Modal modal={modalContra} updateModal={setModalContra} eventModal={() => { createNewItemCC() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <BasicSwitch estado={isPaa} eventChange={(e) => { setIsPaa(e) }} label="Necesidad PAA" />
                        </div>
                        {isPaa ?
                            <>
                                <div className="col-md-12">
                                    <AdquisitionItemSelector idAdquisitionItem={adquisitionItemFrom.IDAdquisitionItem} onChage={(e) => {
                                        if (!e.IDLnBudgetIDNameList) {
                                            toast.warning("La necesidad no tiene correctamente configurado los rubros");
                                            setAdquisitionItemFrom({ IDAdquisitionItem: null })
                                        } else {
                                            setAdquisitionItemFrom(e)
                                        }
                                    }} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                                </div>
                                {adquisitionItemFrom.IDAdquisitionItem &&
                                    <div className="col-md-12">
                                        <SelectBudgetIDByIDAdquisitionItem returnType="Object" idAdquisitionItem={adquisitionItemFrom.IDAdquisitionItem} idSelector={bean.IDBudgetSelected} onChange={(e) => {
                                            const { JsonCode, IDBudgetSource, IDBudgetResource, IDBudgetType } = e || {};

                                            if (!JsonCode || !IDBudgetSource || !IDBudgetResource || !IDBudgetType) {
                                                toast.error("Validar estructuración de los rubros");
                                            } else {
                                                setBean({ ...bean, BudgetIDFromStr: JsonCode, IDBudgetResourceFrom: IDBudgetResource, IDBudgetSourceFrom: IDBudgetSource, Value: e.LeftValue, LeftValue: e.LeftValue, IDBudgetType: IDBudgetType })
                                            }

                                        }} label="Rubro Presupuestal Disponible" />
                                    </div>
                                }
                                {bean.BudgetIDFromStr &&
                                    <div className="col-md-12">
                                        <SelectBudgetID label="Rubro Presupuestal Contra Credito" onChange={(e) => { }} jsonCode={bean.BudgetIDFromStr} disable edit={false} />
                                    </div>
                                }
                                {bean.IDBudgetResourceFrom &&
                                    <div className="col-md-12">
                                        <div className="col-md-12">
                                            <BudgetResourceEditor isDisabled idSelector={bean.IDBudgetResourceFrom} onChange={(e) => { }} />
                                        </div>
                                    </div>
                                }
                                {bean.IDBudgetSourceFrom &&
                                    <div className="col-md-12">
                                        <div className="col-md-12">
                                            <SelectBudgetSource isDisabled idSelector={bean.IDBudgetSourceFrom} onChange={(e) => { }} />
                                        </div>
                                    </div>
                                }
                                {bean.LeftValue > 0 &&
                                    <div className="col-lg-12">
                                        <strong>Valor Maximo:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${bean.LeftValue}` }}></div>
                                    </div>
                                }
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                                    <InputMoney
                                        readonly={bean.LeftValue < 0}
                                        _value={bean.Value}
                                        onChange={(e) => {
                                            if (e > bean.LeftValue) {
                                                toast.error(`El valor no puede superar el monto disponible: ${bean.LeftValue}`);
                                                setBean({ ...bean, "Value": 0 });
                                            } else {
                                                setBean({ ...bean, "Value": e });
                                            }
                                        }}
                                        _label=" "
                                    />
                                </div>
                            </>
                            :
                            <>
                                {!formData.IDBudgetType &&
                                    <div className="col-md-12">
                                        <SelectBudgetType idSelector={bean.IDBudgetType} onChange={(e) => { setBean({ ...bean, "IDBudgetType": e }) }} />
                                    </div>
                                }
                                <div className="col-md-12">
                                    <SelectBudgetID label="Rubro Presupuestal Contra Credito" onChange={(e) => { setBean({ ...bean, "BudgetIDFromStr": e.JsonCode }) }} jsonCode={bean.BudgetIDFromStr} edit={false} />
                                </div>
                                {bean.BudgetIDFromStr &&
                                    <div className="col-md-12">
                                        <SelectBudgetResourceForYear config={{
                                            date: formData.DocumentDate ?? formData.DateForm,
                                            budget: bean.BudgetIDFromStr,
                                        }} idSelector={bean.IDBudgetResourceFrom} onChange={(e) => { setBean({ ...bean, "IDBudgetResourceFrom": e }) }} />
                                    </div>
                                }
                                {bean.IDBudgetResourceFrom &&
                                    <div className="col-md-12">
                                        <SelectBudgetSourceForYear idSelector={bean.IDBudgetSourceFrom} onChange={(e) => { setBean({ ...bean, "IDBudgetSourceFrom": e }) }} cProps={{
                                            budgetIDSTr: bean.BudgetIDFromStr,
                                            budgetResource: bean.IDBudgetResourceFrom,
                                            date: formData.DocumentDate ?? formData.DateForm,
                                        }} />
                                    </div>
                                }
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                                    <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} _label=" " />
                                </div>
                            </>
                        }
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <Modal modal={modalCredit} updateModal={setModalCredit} eventModal={() => { createNewItemCredit() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <BasicSwitch estado={isPaa} eventChange={(e) => { setIsPaa(e) }} label="Necesidad PAA" />
                        </div>
                        {isPaa ?
                            <>
                                <div className="col-md-12">
                                    <AdquisitionItemSelector idAdquisitionItem={adquisitionItemDestiny.IDAdquisitionItem} onChage={(e) => {
                                        if (!e.IDLnBudgetIDNameList) {
                                            toast.warning("La necesidad no tiene correctamente configurado los rubros");
                                            setAdquisitionItemDestiny({ IDAdquisitionItem: null })
                                        } else {
                                            setAdquisitionItemDestiny(e)
                                        }
                                    }} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                                </div>
                                {adquisitionItemDestiny.IDAdquisitionItem &&
                                    <div className="col-md-12">
                                        <SelectBudgetIDByIDAdquisitionItem returnType="Object" idAdquisitionItem={adquisitionItemDestiny.IDAdquisitionItem} idSelector={bean.IDBudgetSelected} onChange={(e) => {
                                            const { JsonCode, IDBudgetSource, IDBudgetResource, IDBudgetType } = e || {};

                                            if (!JsonCode || !IDBudgetSource || !IDBudgetResource || !IDBudgetType) {
                                                toast.error("Complete la información del formulario");
                                            } 
                                            setBean({ ...bean, BudgetIDDestinityStr: JsonCode, IDBudgetResourceDestinity: IDBudgetResource, IDBudgetSourceDestinity: IDBudgetSource, IDBudgetType: IDBudgetType })
                                            console.log(JsonCode)

                                        }} label="Rubro Presupuestal Disponible" />
                                    </div>
                                }
                                {bean.BudgetIDDestinityStr &&
                                    <div className="col-md-12">
                                        <SelectBudgetID label="Rubro Presupuestal Credito" onChange={(e) => { }} jsonCode={bean.BudgetIDDestinityStr} disable edit={false} />
                                    </div>
                                }
                                <div className="col-md-12">
                                    <BudgetResourceEditor idSelector={bean.IDBudgetResourceDestinity} onChange={(e) => { setBean({ ...bean, "IDBudgetResourceDestinity": e }) }} />
                                </div>

                                <div className="col-md-12">
                                    <SelectBudgetSource idSelector={bean.IDBudgetSourceDestinity} onChange={(e) => { setBean({ ...bean, "IDBudgetSourceDestinity": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                                    <InputMoney

                                        _value={bean.Value}
                                        onChange={(e) => {
                                            setBean({ ...bean, "Value": e });
                                        }}
                                        _label=" "
                                    />
                                </div>
                            </>
                            :
                            <>
                                {!formData.IDBudgetType &&
                                    <div className="col-md-12">
                                        <SelectBudgetType idSelector={bean.IDBudgetType} onChange={(e) => { setBean({ ...bean, "IDBudgetType": e }) }} />
                                    </div>
                                }
                                <div className="col-md-12">
                                    <SelectBudgetID label="Rubro Presupuestal Credito" onChange={(e) => { setBean({ ...bean, "BudgetIDDestinityStr": e.JsonCode }) }} jsonCode={bean.BudgetIDDestinityStr} edit={false} />
                                </div>
                                <div className="col-md-12">
                                    <BudgetResourceEditor idSelector={bean.IDBudgetResourceDestinity} onChange={(e) => { setBean({ ...bean, "IDBudgetResourceDestinity": e }) }} />
                                </div>

                                <div className="col-md-12">
                                    <SelectBudgetSource idSelector={bean.IDBudgetSourceDestinity} onChange={(e) => { setBean({ ...bean, "IDBudgetSourceDestinity": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                                    <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} _label=" " />
                                </div>
                            </>
                        }


                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                        {/* <PrintJson json={formData}/> */}
                    </div>
                </Modal>
            </div>
        </div>
    )
}